import {
    useFloating,
    autoUpdate,
    offset,
    flip,
    shift,
    useClick,
    useDismiss,
    useRole,
    useInteractions,
    FloatingFocusManager,
    FloatingPortal,
  } from '@floating-ui/react';
import React from 'react';
   
function PopoverComponent({children, buttonChildren, buttonClassName, open, setOpen}: {children: React.ReactNode, buttonChildren: React.ReactNode, buttonClassName: string, open: boolean, setOpen: (open: boolean) => void}) {
   
    const {refs, floatingStyles, context} = useFloating({
      open: open,
      onOpenChange: setOpen,
      middleware: [offset(5), flip(), shift()],
      whileElementsMounted: autoUpdate,
    });

    const click = useClick(context);
    const dismiss = useDismiss(context, {
      ancestorScroll: true,
    });
    const role = useRole(context);
    
    // Merge all the interactions into prop getters
    const {getReferenceProps, getFloatingProps} = useInteractions([
        click,
        dismiss,
        role,
    ]);

    return (
        <>
          <button ref={refs.setReference} {...getReferenceProps()} className={buttonClassName}>
            {buttonChildren}
          </button>
          <FloatingPortal>
            {open && (
              <FloatingFocusManager context={context} modal={false}>
                <div
                  ref={refs.setFloating}
                  style={floatingStyles}
                  {...getFloatingProps()}
                >
                  {children}
                </div>
              </FloatingFocusManager>
            )}
          </FloatingPortal>
        </>
    );
}

export default PopoverComponent